module.exports = __webpack_public_path__ + "img/13.8ad8913d.png";